import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Footer } from "../components/Footer";
import { Reveal, Label } from "../components/anim";
import { SubscribeBar } from "../components/SubscribeBar";
import { CategoryChips, PostCard } from "../components/blog";
import useSeo from "../hooks/useSeo";
import { PenLine, Loader2 } from "lucide-react";

export default function Blog() {
  const { user } = useAuth();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useSeo({
    title: "Field Notes — The Blog | Andres Campos",
    description: "Writing on pre-development, permitting strategy, AHJ relations, and lessons from a decade across the counter.",
    type: "website",
    url: typeof window !== "undefined" ? window.location.href : undefined,
  });

  useEffect(() => {
    (async () => {
      try {
        const res = await http.get("/posts");
        setPosts(res.data);
      } catch (e) {
        /* ignore */
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <>
      <main className="min-h-screen bg-[#EFEBDE] pt-32 pb-24">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
            <Reveal>
              <Label>Field Notes</Label>
              <h1 className="mt-6 font-display font-semibold uppercase text-5xl md:text-7xl tracking-tighter leading-[0.9] text-[#16281C]">
                The Blog
              </h1>
              <p className="mt-6 font-body text-base md:text-lg text-[#4C5C50] max-w-xl">
                Writing on pre-development, permitting strategy, AHJ relations, and lessons from the field.
              </p>
            </Reveal>
            {user?.is_owner && (
              <Link
                to="/admin/blog"
                data-testid="blog-manage"
                className="inline-flex items-center gap-2 border border-[#16281C]/20 text-[#16281C] font-mono text-[11px] tracking-[0.2em] uppercase px-5 py-3 hover:border-[#2C5F3A] hover:text-[#2C5F3A] transition-colors self-start"
              >
                <PenLine size={14} /> Manage / Write
              </Link>
            )}
          </div>

          <CategoryChips active={null} />

          <div className="mt-12">
            {loading ? (
              <div className="flex justify-center py-24"><Loader2 size={30} className="animate-spin text-[#2C5F3A]" /></div>
            ) : posts.length === 0 ? (
              <div className="text-center py-24">
                <PenLine size={40} className="text-[#8B978C] mx-auto" strokeWidth={1.25} />
                <p className="mt-5 font-body text-[#4C5C50]">No posts published yet. Check back soon.</p>
              </div>
            ) : (
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {posts.map((p, i) => <PostCard key={p.id} p={p} i={i} />)}
              </div>
            )}
          </div>
          <div className="mt-16"><SubscribeBar /></div>
        </div>
      </main>
      <Footer />
    </>
  );
}
